import { CsvHeaderModel } from '../../../models/CsvHeader';

export const MASTER_DIVISION_CSV_HEADER: CsvHeaderModel[] = [
  {
    label: 'id',
    key: 'no_div',
  },
  {
    label: 'masterDivisionNameEn',
    key: 'division_name_en',
  },
  {
    label: 'masterDivisionNameLa',
    key: 'division_name_la',
  },
  {
    label: 'masterMainGroupName',
    key: 'master_main_group_name',
  },
  {
    label: 'description',
    key: 'description',
  },
  {
    label: 'code',
    key: 'code',
  },
];
